export const AVATAR_GAP = 0.5

export const AVATAR_SIZE = {
  small: 2.25,
  medium: 3,
  large: 4,
  extraLarge: 5,
} as const
